<template>
    <div class="stars" :class="{'stars--small': small}">
        <img :src="iconFull" class="star star--full" :class="{'star--small': small}" v-for="n in fullStars" alt="Full star icon" />
        <img :src="iconHalf" class="star star--half" :class="{'star--small': small}" v-for="n in halfStars" alt="Half star icon" />
        <img :src="iconEmpty" class="star star--empty" :class="{'star--small': small}" v-for="n in emptyStars" alt="Empty star icon" />
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            max: {
                type: Number,
                default: 5
            },
            value: {
                type: Number,
                default: 2.5
            },
            small: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            iconFull() {
                return '/icons/star-full.svg';
            },
            iconHalf() {
                return '/icons/star-half.svg';
            },
            iconEmpty() {
                return '/icons/star-empty.svg';
            },
            fullStars()
            {
                return parseInt(this.value);
            },
            halfStars()
            {
                let parts = (this.value + "").split(".");
                if ( parts[1] ) {
                    return 1;
                }
                return 0;
            },
            emptyStars()
            {
                if ( this.value == this.max ) {
                    return 0;
                }
                return this.max - ( this.fullStars + this.halfStars );
            }
        }
    }
</script>